import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Admin.css';

const AdminLogin = () => {
    const [email, setEmail] = useState('admin@pitac.gov.pk');
    const [password, setPassword] = useState('admin123');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            // Direct login without CSRF - this works with curl
            const response = await axios.post('https://pitac.gov.pk/api/admin/login', {
                email,
                password
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            });

            console.log('Login response:', response.data);

            if (response.data.token) {
                localStorage.setItem('admin_token', response.data.token);
                localStorage.setItem('admin_user', JSON.stringify(response.data.user));
                axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                navigate('/admin');
            } else {
                setError('No token received from server');
            }
        } catch (err) {
            console.error('Login error:', err);
            
            let errorMessage = 'Login failed. Please check your credentials.';
            
            if (err.response) {
                errorMessage = err.response.data?.message || err.response.statusText || errorMessage;
                console.log('Response data:', err.response.data);
                console.log('Response status:', err.response.status);
            } else if (err.request) {
                errorMessage = 'Cannot connect to server. Make sure the backend is running.';
                console.log('Request error:', err.request);
            }
            
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-page">
            <div className="admin-login-container">
                <div className="admin-login-box">
                    <div className="admin-login-header">
                        <img src="/images/pitac-logo1.png" alt="PITAC" className="admin-login-logo" />
                        <h2>Admin Panel</h2>
                        <p>Sign in to manage your website</p>
                    </div>
                    
                    {error && <div className="admin-error">{error}</div>}
                    
                    <form onSubmit={handleSubmit} className="admin-login-form">
                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@pitac.gov.pk"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                        </div>
                        <button type="submit" className="admin-login-btn" disabled={loading}>
                            {loading ? 'Logging in...' : 'Sign In'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;